export default {
  auth: () => import("/vercel/path0/apps/app/layouts/auth.vue"),
  default: () => import("/vercel/path0/apps/app/layouts/default.vue"),
  document: () => import("/vercel/path0/apps/app/layouts/document.vue"),
  plain: () => import("/vercel/path0/apps/app/layouts/plain.vue"),
  settings: () => import("/vercel/path0/apps/app/layouts/settings.vue"),
  "with-sidebar": () => import("/vercel/path0/apps/app/layouts/with-sidebar.vue"),
  "with-top-bar": () => import("/vercel/path0/apps/app/layouts/with-top-bar.vue")
}